import { useMutation } from '@tanstack/react-query';
import apiClient from 'core/services/apiClient/apiClient';

export const usePatchRest = <TPostResult, TBody>(pathURL: string) => {
  return useMutation<TPostResult, Error, TBody>({
    mutationFn: async (body) => {
      const { data } = await apiClient.patch<TPostResult>(pathURL, body);
      return data;
    }
  });
};
